import { Box, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'
import { useAccountSubscsriptionPlan } from 'src/providers/account-subscription-provider'

export const AccountSubscriptionBanner = () => {
  const [t] = useTranslation()
  const theme = useTheme()
  const { isAccount, isActive, isBillingHidden, accountId } = useAccountSubscsriptionPlan()

  if (!isAccount || isActive || isActive === null) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        background: theme.palette.custom.primary,
        margin: 0,
        zIndex: 100,
        position: 'relative',
        color: theme.palette.common.white,
        padding: '10px 20px',
      }}
    >
      <Typography sx={{ fontSize: '12px' }}>
        {t('account-subscription-banner-text-1.v')}{' '}
        <Link
          style={{
            fontWeight: 'bold',
            textDecoration: 'underline',
            cursor: 'pointer',
            color: '#fff',
            fontSize: '12px',
          }}
          to={joinAbsRoute(
            ROUTES.ACCOUNTS,
            accountId,
            isBillingHidden ? ROUTES.ACCOUNT_SUPPORT : `${ROUTES.ACCOUNT}?tab=billing`,
          )}
        >
          {t('account-subscription-banner-text-2.v')}
        </Link>
      </Typography>
    </Box>
  )
}
